import { render, staticRenderFns } from "./HistoricoPacotesPaciente.vue?vue&type=template&id=f7803dee&"
import script from "./HistoricoPacotesPaciente.vue?vue&type=script&lang=js&"
export * from "./HistoricoPacotesPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports